import {
  DocumentAmendment,
  ProcessedAmendment,
  RawAmendment,
  RawClauseChange,
} from "common/flowmaster/types/amendment";
import hash from "object-hash";

export const processDocumentAmendments = (
  amendments: DocumentAmendment[],
  explanation?: string,
): ProcessedAmendment[] => {
  if (amendments.length === 0) {
    return [];
  }
  const clauseChanges = amendments.map(amendment => ({
    id: hash(amendment),
    clause_id: "",
    clause_reference: amendment.clause_reference ?? "",
    section_reference: amendment.section_reference,
    added_text: amendment.added_text,
    deleted_text: amendment.deleted_text,
    comment_text: amendment.comment_text ?? "",
    replacement_context: {
      before: amendment.before_text,
      after: amendment.after_text,
      is_before_on_newline:
        amendment.is_before_text_on_newline === true ||
        amendment.is_before_text_on_newline === "true",
      is_after_on_newline:
        amendment.is_after_text_on_newline === true ||
        amendment.is_after_text_on_newline === "true",
    },
    insert_after: amendment.action_type === "insert_after",
    insert_before: amendment.action_type === "insert_before",
    detach_from_list: amendment.detachFromList ?? false,
    delete:
      amendment.action_type === "delete" ||
      amendment.action_type === "delete_clause",
    comment_applied: false,
    rawAmendment: amendment,
  }));

  return [
    {
      explanation: explanation ?? "Amend and minimise redline",
      explanationMeta: amendments[0]?.rationale,
      clause_changes: clauseChanges,
    },
  ];
};

export const processAmendments = (
  amendments: RawAmendment[],
): ProcessedAmendment[] => {
  return amendments.map(amendment => {
    const processedChanges = amendment.clause_changes.map(
      (change: RawClauseChange) => {
        const {
          insert_after,
          insert_before,
          delete: deleteFlag,
          detach_from_list,
          ...rest
        } = change;

        return {
          ...rest,
          insert_after: insert_after === "true",
          insert_before: insert_before === "true",
          detach_from_list: detach_from_list === "true",
          delete: deleteFlag === "true",
          comment_applied: false,
          id: hash(change),
        };
      },
    );

    return {
      ...amendment,
      clause_changes: processedChanges,
    };
  });
};
